<template>
  <div>
    <div class="mb-4 flex align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Home</span>
    </div>
    <div class="grid mb-2">
      <div class="col-12 md:col-9">
        <div class="text-[20px!important] font-bold text-gray-800">
          Overview {{ currentMonth }} {{ currentYear }}
        </div>

        <div class="text-sm text-gray-500">
          Ringkasan progress dan total transaksi bulan ini
        </div>
      </div>
    </div>

    <div class="grid gap-4">
      <div
        v-for="(item, index) in summaryCards"
        :key="index"
        class="col-12 md:col-4 lg:col-2"
      >
        <div
          class="
            card
            p-4
            flex flex-col
            justify-between
            border border-surface-200
            rounded-xl
            cursor-pointer
            transition-all
            hover:shadow-md hover:scale-[1.02]
          "
          @click="navigateTo(item.route)"
        >
          <div class="flex items-start w-full">
            <!-- Icon -->
            <div
              class="rounded-full p-2 mr-3 flex items-center justify-center"
              :style="{ color: item.color }"
            >
              <i :class="item.icon" class="text-lg"></i>
            </div>

            <!-- Info -->
            <div class="flex-1">
              <div class="text-sm font-semibold text-gray-600 mb-1">
                {{ item.title }}
              </div>
              <div class="text-[18px] font-bold text-gray-900">
                Invoice: {{ formatCurrency(item.total_invoice) }} data
              </div>
              <div class="text-xs text-gray-500">
                Total Item: {{ item.total_item }} data
              </div>
              <div class="text-xs text-gray-500">
                Total Qty: {{ item.total_qty }}
              </div>

              <!-- Progress Invoice -->
              <div class="text-xs font-medium text-gray-500 mt-2 mb-1">
                Progress Invoice
              </div>
              <div class="relative w-full progress-container">
                <ProgressBar
                  :value="item.progress_invoice ?? 0"
                  class="w-full progress-custom"
                  :class="`progress-${index}`"
                  :showValue="false"
                />
                <div class="progress-text">
                  {{ (item.progress_invoice ?? 0).toFixed(1) }}%
                </div>
              </div>

              <!-- Progress Item -->
              <div class="text-xs font-medium text-gray-500 mt-2 mb-1">
                Progress Item
              </div>
              <div class="relative w-full progress-container">
                <ProgressBar
                  :value="item.progress_item ?? 0"
                  class="w-full progress-custom"
                  :class="`progress-item-${index}`"
                  :showValue="false"
                />
                <div class="progress-text">
                  {{ (item.progress_item ?? 0).toFixed(1) }}%
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Label di bawah card -->
        <div class="text-center text-xs text-gray-500 mt-2 font-medium">
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- Chart -->
    <div class="grid mb-2 mt-5">
      <div class="col-12 md:col-9">
        <div class="text-[20px!important] font-bold text-gray-800">
          Penjualan Tahun {{ currentYear }}
        </div>

        <div class="text-sm text-gray-500">
          Total penjualan per bulan selama tahun ini
        </div>
      </div>
    </div>
    <div class="card bg-white mb-3">
      <div class="grid">
        <div class="col-12">
          <Chart
            type="line"
            :data="chartData"
            :options="chartOptions"
            class="h-64"
            style="min-height: 300px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/helpers'
import DashboardService from '@/services/DashboardService'
import dayjs from 'dayjs'
import 'dayjs/locale/id'
import Chart from 'primevue/chart'
dayjs.locale('id')

export default {
  name: 'Home',
  components: { Chart },
  data() {
    return {
      cards: null,
      chartData: null,
      chartOptions: null,
      dashboardService: null,
      currentMonth: dayjs().format('MMMM'),
      currentYear: dayjs().format('YYYY'),
      summaryCards: [],
      totalPenjualan: 0,
    }
  },
  created() {
    this.dashboardService = new DashboardService()
  },
  mounted() {
    this.loadDashboard()
  },
  methods: {
    async loadDashboard() {
      try {
        const res = await this.dashboardService.get()
        const { cards, charts } = res.data
        this.cards = cards

        // otomatis susun data summaryCards dari API
        this.summaryCards = [
          // -------------------- PEMBELIAN --------------------
          // {
          //   title: 'Pembelian (draft)',
          //   total: cards.pembelian.draft.total,
          //   total_invoice: cards.pembelian.draft.total_invoice,
          //   total_item: cards.pembelian.draft.total_item,
          //   total_qty: cards.pembelian.draft.total_qty,
          //   progress_invoice: cards.pembelian.draft.progress_invoice,
          //   progress_item: cards.pembelian.draft.progress_item,
          //   icon: 'pi pi-shopping-bag',
          //   label: 'Pembelian Draft',
          //   color: '#60A5FA !important',
          //   route: '/pembelian/order',
          // },
          {
            title: 'Pembelian (done)',
            total: cards.pembelian.done.total,
            total_invoice: cards.pembelian.done.total_invoice,
            total_item: cards.pembelian.done.total_item,
            total_qty: cards.pembelian.done.total_qty,
            progress_invoice: cards.pembelian.done.progress_invoice,
            progress_item: cards.pembelian.done.progress_item,
            icon: 'pi pi-check-circle',
            label: 'Pembelian Done',
            color: '#22C55E',
            route: '/pembelian/order',
          },

          // -------------------- PENERIMAAN --------------------
          {
            title: 'Penerimaan (draft)',
            total: cards.penerimaan.draft.total,
            total_invoice: cards.penerimaan.draft.total_invoice,
            total_item: cards.penerimaan.draft.total_item,
            total_qty: cards.penerimaan.draft.total_qty,
            progress_invoice: cards.penerimaan.draft.progress_invoice,
            progress_item: cards.penerimaan.draft.progress_item,
            icon: 'pi pi-truck',
            label: 'Penerimaan Draft',
            color: '#FACC15',
            route: '/pembelian/receive',
          },
          {
            title: 'Penerimaan (printed)',
            total: cards.penerimaan.printed.total,
            total_invoice: cards.penerimaan.printed.total_invoice,
            total_item: cards.penerimaan.printed.total_item,
            total_qty: cards.penerimaan.printed.total_qty,
            progress_invoice: cards.penerimaan.printed.progress_invoice,
            progress_item: cards.penerimaan.printed.progress_item,
            icon: 'pi pi-print',
            label: 'Penerimaan Printed',
            color: '#A855F7',
            route: '/pembelian/receive',
          },
          {
            title: 'Penerimaan (posted)',
            total: cards.penerimaan.posted.total,
            total_invoice: cards.penerimaan.posted.total_invoice,
            total_item: cards.penerimaan.posted.total_item,
            total_qty: cards.penerimaan.posted.total_qty,
            progress_invoice: cards.penerimaan.posted.progress_invoice,
            progress_item: cards.penerimaan.posted.progress_item,
            icon: 'pi pi-send',
            label: 'Penerimaan Posted',
            color: '#22D3EE',
            route: '/pembelian/receive',
          },

          // -------------------- PENJUALAN --------------------
          {
            title: 'Penjualan (done)',
            total: cards.penjualan.done.total,
            total_invoice: cards.penjualan.done.total_invoice,
            total_item: cards.penjualan.done.total_item,
            total_qty: cards.penjualan.done.total_qty,
            progress_invoice: cards.penjualan.done.progress_invoice,
            progress_item: cards.penjualan.done.progress_item,
            icon: 'pi pi-shopping-cart',
            label: 'Penjualan Done',
            color: '#F97316',
            route: '/penjualan/order',
          },

          // -------------------- RETUR --------------------
          // {
          //   title: 'Retur (draft)',
          //   total: cards.retur.draft.total,
          //   total_invoice: cards.retur.draft.total_invoice,
          //   total_item: cards.retur.draft.total_item,
          //   total_qty: cards.retur.draft.total_qty,
          //   progress_invoice: cards.retur.draft.progress_invoice,
          //   progress_item: cards.retur.draft.progress_item,
          //   icon: 'pi pi-refresh',
          //   label: 'Retur Draft',
          //   color: '#FACC15',
          //   route: '/pembelian/retur',
          // },
          {
            title: 'Retur (done)',
            total: cards.retur.done.total,
            total_invoice: cards.retur.done.total_invoice,
            total_item: cards.retur.done.total_item,
            total_qty: cards.retur.done.total_qty,
            progress_invoice: cards.retur.done.progress_invoice,
            progress_item: cards.retur.done.progress_item,
            icon: 'pi pi-refresh',
            label: 'Retur Done',
            color: '#EF4444',
            route: '/pembelian/retur',
          },
        ]

        // -------------------- CHART PENJUALAN PER BULAN --------------------
        const penjualan = charts.penjualan

        // urutkan bulan biar selalu Januari–Desember
        const monthOrder = [
          'Januari',
          'Februari',
          'Maret',
          'April',
          'Mei',
          'Juni',
          'Juli',
          'Agustus',
          'September',
          'Oktober',
          'November',
          'Desember',
        ]
        const labels = monthOrder.filter((m) => penjualan[m] !== undefined)
        const values = labels.map((m) => penjualan[m] ?? 0)

        // total penjualan
        const totalPenjualan = values.reduce((a, b) => a + b, 0)
        this.totalPenjualan = totalPenjualan

        this.chartData = {
          labels,
          datasets: [
            {
              label: 'Penjualan',
              data: values,
              borderColor: '#42A5F5',
              backgroundColor: 'rgba(66,165,245,0.2)',
              fill: true,
              tension: 0.4,
              pointBackgroundColor: '#1E88E5',
              pointRadius: 4,
            },
          ],
        }

        this.chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'top' },
            tooltip: {
              callbacks: {
                label: (context) =>
                  `Rp ${Number(context.raw).toLocaleString('id-ID')}`,
              },
            },
            title: {
              display: true,
              text: `Total Penjualan: Rp ${totalPenjualan.toLocaleString(
                'id-ID'
              )}`,
              font: { size: 16, },
              color: '#374151',
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              title: { display: true, text: 'Nilai Penjualan (Rp)' },
            },
            x: {
              title: { display: true, text: 'Bulan' },
            },
          },
        }
      } catch (e) {
        console.error(e)
      }
    },
    navigateTo(route) {
      if (route) this.$router.push(route)
    },
    formatCurrency(value, minDigit = 0, maxDigit = 0) {
      return formatCurrency(value, minDigit, maxDigit)
    },
  },
}
</script>

<style scoped>
.chart-container {
  height: 30vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}
.chart-container ::v-deep(canvas) {
  flex: 1;
}

/* gunakan deep selector agar override warna PrimeVue */
::v-deep(.progress-custom .p-progressbar-value) {
  background-color: var(--progress-color);
}

/* progress bar dinamis */
.progress-0 ::v-deep(.p-progressbar-value) {
  background-color: #60a5fa !important; /* biru */
}
.progress-1 ::v-deep(.p-progressbar-value) {
  background-color: #22c55e !important; /* hijau */
}
.progress-2 ::v-deep(.p-progressbar-value) {
  background-color: #facc15 !important; /* kuning */
}
.progress-3 ::v-deep(.p-progressbar-value) {
  background-color: #a855f7 !important; /* kuning */
}
.progress-4 ::v-deep(.p-progressbar-value) {
  background-color: #22d3ee !important; /* kuning */
}
.progress-5 ::v-deep(.p-progressbar-value) {
  background-color: #f97316 !important; /* kuning */
}
.progress-6::v-deep(.p-progressbar-value) {
  background-color: #facc15 !important; /* kuning */
}
.progress-7 ::v-deep(.p-progressbar-value) {
  background-color: #ef4444 !important; /* kuning */
}

/* item progress (kalau mau beda) */
.progress-item-0 ::v-deep(.p-progressbar-value) {
  background-color: #3b82f6 !important;
}
.progress-item-1 ::v-deep(.p-progressbar-value) {
  background-color: #16a34a !important;
}
.progress-item-2 ::v-deep(.p-progressbar-value) {
  background-color: #facc15 !important;
}
.progress-item-3 ::v-deep(.p-progressbar-value) {
  background-color: #a855f7 !important;
}
.progress-item-4 ::v-deep(.p-progressbar-value) {
  background-color: #22d3ee !important;
}
.progress-item-5 ::v-deep(.p-progressbar-value) {
  background-color: #f97316 !important;
}
.progress-item-6 ::v-deep(.p-progressbar-value) {
  background-color: #facc15 !important;
}
.progress-item-7 ::v-deep(.p-progressbar-value) {
  background-color: #ef4444 !important;
}

.progress-container {
  position: relative;
}

.progress-container .p-progressbar {
  height: 1.25rem; /* opsional, tinggi bar */
  border-radius: 9999px;
  overflow: visible !important;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem; /* text-xs */
  font-weight: 600;
  color: #374151; /* gray-700 */
  z-index: 2;
  pointer-events: none;
}
</style>
